<template>
    <div class="base-page">
        <Nav> </Nav>
        <slot></slot>
        <Footer :contactData="contactData" v-if="route.path != '/start'"> </Footer>
        <!-- 侧边栏 -->
        <Contact :contactData="contactData" v-if="route.path != '/start'"> </Contact>
    </div>
</template>

<script setup>
    import Footer from './footer.vue';
    import Nav from './nav.vue';
    import Contact from './contact.vue';  

    import { onMounted, ref } from 'vue';
    import { ConfigGetAPI } from '@/api/common.js';

    import { useRoute } from 'vue-router'
    const route = useRoute();

   // 联系我们
    const contactParam = ref({ name: "about_contact" })

    // 联系我们数据
    const contactData = ref({})

    // 获取联系我们数据
    const getContactData = () => {  
        ConfigGetAPI(contactParam.value).then(res => {
            contactData.value = res
        });
    }

    onMounted(() => {
        getContactData();
    });
</script>

<style lang="scss" scoped>
    .base-page {
        font-family: 'PingFangSC-regular';
        min-width: 1200px;
    }
        /* 响应式设计 */
    @media (max-width: 768px) {
        .base-page {
            min-width: 100%;
        }
    }
</style>